<!-- Receives an object with all the fields and properties to build it -->
<div *ngIf="isCurrentStatus('create') || isCurrentStatus('update')">
    <mat-card class="card-bordered margin-top-1rem">
      <app-dynamic-crud-field  [fieldsToRender]="build()" [crudId]="crudConfig.id"></app-dynamic-crud-field>
    
      <div *ngIf="crudConfig.showCreateUpdateButtons" class="flex space-between topmargin-sm bottommargin-sm">
          
          <button mat-icon-button color="primary" *ngIf="isCurrentStatus('create') || isCurrentStatus('update')" (click)="setCurrentStatus('read')" aria-label="">
              <mat-icon><i class="fas fa-arrow-circle-left"></i></mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="showDebugCard = !showDebugCard" aria-label="">
              <mat-icon>developer_mode</mat-icon>
          </button>
          <button *ngIf="isCurrentStatus('create')" mat-icon-button color="primary" (click)="create()" aria-label="">
              <mat-icon><i class="fas fa-plus-circle"></i></mat-icon>
          </button>
          <button mat-icon-button  *ngIf="isCurrentStatus('update')" (click)="saveChanges()" color="primary" aria-label="">
              <mat-icon>save</mat-icon>
          </button>
      </div>
    </mat-card>
    
    <mat-accordion class="debug-card"  *ngIf="showDebugCard">
        <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
               Debug info:
              </mat-panel-title>
              <mat-panel-description>
                
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="flex-column">
                <span>Table: {{ crudConfig.tableName }}</span>
                <span>Crud id: {{ crudConfig.id }}</span>
                <span>Status: {{getCurrentStatusAsString()}}</span>
                <span style="word-wrap: break-word;font-family: monospace;">{{getCurrentObjectAsString()}}</span>
            </div>
            
          </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Current Object
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <span style="word-wrap: break-word;font-family: monospace;">Current Object: {{getCurrentObjectAsString()}}</span>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Last inserted
            </mat-panel-title>
            <mat-panel-description>
              
            </mat-panel-description>
          </mat-expansion-panel-header>
          <span style="word-wrap: break-word;font-family: monospace;">Last Inserted: {{getLastInsertedObjectAsString()}}</span>
        </mat-expansion-panel>
      </mat-accordion>
</div>

<p *ngIf="!tableProperties">No properties object loaded</p>

<div class="button-row">
    <button *ngIf="isCurrentStatus('read')" mat-fab color="primary" (click)="addNewRow()"><i class="fas fa-plus"></i></button>
</div>
